module.exports = __webpack_public_path__ + "static/media/index.497f5ee2.mjs";